//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { textsDefaul, envConfig, TYPE_CHANGE_METADA, TAG_QUERIES, DEFAULT_TPL_FIELDS, ALL_TABLES_OPTION, TYPSE_SENSE_TYPE_OBJECTS, ACCESS_TYPE_FLOW, GA_EVENTS } from '@/js/constants';
export default {
  name: 'ItemTblDashboardComponent',
  props: {
    item: {
      type: Object,
      require: true
    }
  },
  components: {},
  computed: {},
  data: function data() {
    return {
      TYPSE_SENSE_TYPE_OBJECTS: TYPSE_SENSE_TYPE_OBJECTS
    };
  },
  mounted: function mounted() {},
  created: function created() {},
  methods: {
    similarityPercent: function similarityPercent(distance) {
      return Math.round((1 - distance) * 100);
    },
    similarityColor: function similarityColor(distance) {
      var pct = (1 - distance) * 100;
      return pct >= 85 ? 'success' : pct >= 75 ? 'warning' : 'error';
    },
    onVerObjeto: function onVerObjeto(item) {
      this.$emit("onVerObjeto", item);
    },
    onRequestObjeto: function onRequestObjeto(item) {
      this.$emit("onRequestObjeto", item);
    },
    onChangeObjeto: function onChangeObjeto(item) {
      this.$emit("onChangeObjeto", item);
    }
  }
};